module.exports = __webpack_public_path__ + "static/media/1023275.11b64c75.png";